import { EventEmitter, Injectable, inject } from "@angular/core";
import { User } from "./user.model";
import { UserRepository } from "./user.repository";
import { NgxPermissionsService } from "ngx-permissions";
import { AuthHttpConfig } from "../security/authorization/auth-http-config";

@Injectable()
export class UserService {
  private userRepository = inject(UserRepository);
  private permissionService = inject(NgxPermissionsService);
  private authHttpConfig = inject(AuthHttpConfig);

  public serviceUserChange = new EventEmitter<number>();
  private userPromise: Promise<User> = null;

  public loginUser(loginData) {
    this.authHttpConfig.setToken(loginData.token);
    this.authHttpConfig.setRefreshToken(loginData.refresh_token ?? null);
    this.serviceUserChange.emit(loginData.id);
  }

  public clearUser() {
    this.userPromise = null;
    this.authHttpConfig.removeToken();
    this.authHttpConfig.removeRefreshToken();
    this.authHttpConfig.removeImpersonatedUsername();
    this.permissionService.flushPermissions();
    this.serviceUserChange.emit(0);
  }

  public getUser(): Promise<User> {
    if (null !== this.userPromise) {
      return this.userPromise;
    }

    if (this.authHttpConfig.getToken() !== null) {
      this.userPromise = this.userRepository.getUser().toPromise();

      return this.userPromise;
    }

    return Promise.resolve(null);
  }
}
